module.exports = __webpack_public_path__ + "img/license5.680637b5.png";